export const TriggersEditor = {
  attributes: {
    violationCountInput: "violation-count-input",
    totalTimeOrPointsInput: "total-time-or-points-input",
    errorMessage: "triggers-validation-error"
  }
};
